export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11257.b31c1498.jpg";